import { DomSanitizer } from '@angular/platform-browser';
import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SecurityModalComponent } from './../partials/security-modal/security-modal.component';
import { ReportesService } from './../../services/reportes.service';
import { ReportePorObraService } from '../../services/reporte-por-obra.service';
import { AutenticacionService, ModulosARK, TipoPermiso } from './../../services/autenticacion.service';


@Component({
  selector: 'app-reporte-por-obra',
  templateUrl: './reporte-por-obra.component.html',
  styleUrls: ['./reporte-por-obra.component.scss']
})
export class ReportePorObraComponent implements OnInit {

  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;
  public reportes_lista: any[] = [];
  public reporte_actual: any;
  public fecha_actual: any;
  public fecha_filter: any;
  public inversionista_filter: any = {};
  public inversionista_options: any[];
  public obra_filter: any;
  public obra_options: any[];
  public securityActived: any = false;
  public reporte_selected: any = {};
  public obra_selected: any;
  public arrayInversionistas:any = [];
  public arrayInversionistasGrupos:any = [];
  public arrayInversionistasList:any = [];
  public validarInversionistasList:any='starting';
  public primera_seleccion: boolean = true;
  public inversionista_selected: any = {};
  public lodingInformacionInversionista:boolean = true;
  public obra:any={};
  public resultados :any= {};
  public retornoHistorico:any = {};
  public inversionistas:any = {};
  public retornos:any = [];
  public loading_report: any = true;
  public show_report: any = false;
  public not_report: any = false;
  public printing: boolean = false;
  public report_request: any;
  private chart_ready_pending: boolean = false;
  private loader_fallback_timeout: any;
  private fecha_loaded: boolean = false;
  private pending_reporte: boolean = false;

  constructor(
              private reportesService: ReportesService,
              private reportePorObraService: ReportePorObraService,
              private router: Router, private activedRoute: ActivatedRoute,
              private helperService: HelpersService, private sanitizer: DomSanitizer,
              private authService: AutenticacionService) { }

  ngOnInit() {
    this.start();
    this.startReporteSelected();
    this.getObras();
  }

  start() {
    let reportes_lista = this.reportesService.getListaReportes();
    for (let i = 0; i < reportes_lista.length; i++) {  
      if(reportes_lista[i]["id"] == 1 && this.authService.tienenPermisos(ModulosARK.ReportePorInversionista, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 2 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 3 && this.authService.tienenPermisos(ModulosARK.ReportePorObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
        this.reporte_actual = reportes_lista[i]; // reporte por inversionista
      }
      if(reportes_lista[i]["id"] == 4 && this.authService.tienenPermisos(ModulosARK.ReporteBalanceKr, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 5 && this.authService.tienenPermisos(ModulosARK.ReportePuntoDeEquilibrio, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 6 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeDiferencia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 7 && this.authService.tienenPermisos(ModulosARK.ReporteSaldos, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 8 && this.authService.tienenPermisos(ModulosARK.ReporteDepositoGarantia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 9 && this.authService.tienenPermisos(ModulosARK.ReporteCobranza, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
    }

    this.getFechaActual();
  }

  startReporteSelected() {
    this.obra_selected = this.reportePorObraService.getDefaultSchedule();
  }

  getObras() {
    this.reportePorObraService.getObras()
      .subscribe(response => {
        const content_response = response.json().content;
        this.obra_options = content_response;
        console.log("obras: ", this.obra_options);
        if (this.obra_options.length > 0) {
          this.changeInversionistaFilterObra(this.obra_options[0]);
        }
        
      }, error => {
        this.reporte_selected = {};
        this.helperService.httpGlobalError(error);
      });
  }

  changeInversionistaFilterObra(obra) {
    this.obra_filter = obra;
    this.inversionista_filter = {};
    if (this.obra_filter.idObras) {
      this.getInversionistas(this.obra_filter.idObras);
    }
  }

  getInversionistas(data){
    this.arrayInversionistas = [];
    this.arrayInversionistasGrupos = [];
    this.arrayInversionistasList = [];
    this.reportePorObraService.getInversionistasByObra(data)
      .subscribe((response) => {
        const content_response = response.json().content;
        let arrayInversionistasList = [];
        let firstInversionista;
        if(content_response.inversionistas_obras.length > 0)
        {
          this.arrayInversionistas = content_response.inversionistas_obras;
          if (this.arrayInversionistas.length > 0) {
            firstInversionista = JSON.parse(JSON.stringify( this.arrayInversionistas[0] ));
          }
          this.agregarLabel();
          
          const respuesta = response.json();
          arrayInversionistasList.push({
              'text': 'Inversionistas',
              'children': this.arrayInversionistas,
              'key': 'idInversionistas',
              'label': 'nombre'
            });
        }
        if(content_response.inversionistas_obras_grupos.length > 0)
        {
          content_response.inversionistas_obras_grupos.forEach((label)=> 
          {
            this.arrayInversionistasGrupos = label.inversionistas_obras_grupos_elementos;
            this.agregarLabelGrupo();

            let copy = JSON.parse(JSON.stringify(this.arrayInversionistasGrupos));
            arrayInversionistasList.push({
              'text': label.inversionistas_grupos.nombre,
              'children': copy,
              'key': 'idInversionistas',
              'label': 'nombre'
            });
          });
        }
        this.arrayInversionistasList = arrayInversionistasList;
        console.log("getInversionistasList: ",this.arrayInversionistasList);
        if (this.arrayInversionistas.length > 0) {
          this.changeInversionistaFilter(firstInversionista);
        } else {
          this.getReporte();
        }
        
      },(error) => {
      // resuelve errores 403, 500 y sin conexión.
      this.helperService.httpGlobalError(error);
    });
  }

  agregarLabel(){
    this.arrayInversionistas.forEach((label)=> {
      label.nombre = label.inversionistas.nombre;
    });
  }

  agregarLabelGrupo(){
    this.arrayInversionistasGrupos.forEach((label)=> {
      label.nombre = label.inversionistas.nombre;
    });
  }

  getFechaActual() {
    this.reportesService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          this.fecha_actual = content.fecha;
          this.fecha_filter = this.fecha_actual;
          this.fecha_loaded = true;
          // Si la cadena de obras/inversionistas ya intento disparar reporte
          // sin tener fecha lista, lo disparamos ahora una sola vez.
          if (this.pending_reporte) {
            this.pending_reporte = false;
            this.getReporte();
          }
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);

          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
        });
  }

  changeInversionistaFilterFecha(fecha) {
    this.fecha_filter = fecha;
    // Loader inmediato para que no se vea data vieja durante el debounce
    this.loading_report = true;
    setTimeout(() => {
      this.getReporte();
    }, 200);
  }

  changeInversionistaFilter(inversionista) {
    console.log('to change inversionista ', inversionista);
    this.inversionista_filter = inversionista;
    this.getReporte();
  }

  getReporte() {

    if (!this.obra_filter || !this.obra_filter.idObras) {
      console.log('no se puede generar un reporte de obra sin una obra seleccionada');
      return false;
    }

    // Si la fecha aun no se cargo, marcar pendiente y esperar a que getFechaActual termine
    if (!this.fecha_loaded) {
      this.pending_reporte = true;
      this.loading_report = true;
      return false;
    }

    this.reporte_selected = [];
    this.retornoHistorico = {};
    this.loading_report = true;
    this.show_report = false;
    this.chart_ready_pending = true;
    if (this.report_request) {
      this.report_request.unsubscribe();
    }
    if (this.loader_fallback_timeout) {
      clearTimeout(this.loader_fallback_timeout);
    }
    this.report_request = this.reportePorObraService.getReporte(this.obra_filter.idObras, this.inversionista_filter.idInversionistas, this.fecha_filter)
      .subscribe((response) => {
        const content_response = response.json().content;
        this.reporte_selected = content_response;
        this.obra = content_response.obra;
        this.resultados = content_response.resultados;
        this.retornoHistorico = this.reporte_selected.retonosHistoricos;
        this.inversionistas = content_response.inversionistas;
        this.show_report = true;
        this.not_report = false;
        // Loader se baja al chartReady; fallback de seguridad 2.5s
        this.loader_fallback_timeout = setTimeout(() => {
          if (this.loading_report) {
            this.loading_report = false;
            this.chart_ready_pending = false;
          }
        }, 2500);
      }, (error) => {
        // resuelve errores 403, 500 y sin conexión.
        this.helperService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
        this.chart_ready_pending = false;
      });
  }

  onChartReady() {
    if (this.chart_ready_pending) {
      this.chart_ready_pending = false;
      this.loading_report = false;
      if (this.loader_fallback_timeout) {
        clearTimeout(this.loader_fallback_timeout);
        this.loader_fallback_timeout = null;
      }
    }
  }

  // SEGURITY MODULE
  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.getObras();
            this.securityActived = false;
            this.securityModal.push({
            'passwordActivated': false
          });
          }
        });
    }
  }

  canSecurity() {
    return this.reportesService.canSecurity();
  }

  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.reportesService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if(respuesta.success === true) {
          this.getObras();
          this.securityModal.push({
            'passwordActivated': true
          });
          this.securityModal.close();
          this.securityActived = true;
        }
      }, (error) => {
        this.securityModal.loading = false;
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
        this.securityActived = false;
        this.securityModal.push({
          'passwordActivated': false
        });
      })
  }

  changeReporte(reporte) {
    if (reporte.id && reporte.id != this.reporte_actual.id) {
      this.router.navigate([reporte.ruta]);
    }
  }

  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    }, 1200);
    window.onafterprint = window.onbeforeprint= () => {
      console.log('end to print');
      this.printing = false;
    };
  }

  
  return() {
    this.router.navigate(['/catalogo-reportes']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-por-obra/reporte-por-obra.component.ts